import React from 'react';
import PropTypes from 'prop-types';

// UNLEASH
//import { useUnleashContext, useFlag } from '@unleash/proxy-client-react';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';



const CategorieSelect = ({ value, categories, error, isRequired, afficheAide, autoFocus, disabled, onChange }) => {

    let aide = '';
    if (afficheAide) {
        let categorie = categories.find(x => x.id === value);
        if (categorie) {
            aide = categorie.aide;
        }
    }

    const handleChange = (event) => {

        onChange(event, categories.find(x => x.id === event.target.value));
    };

    const handleKeyDown = (event) => {

        let categorie = categories.find(c => c.libelle.substring(0, 1).toUpperCase() === event.key.toUpperCase());

        if (categorie) {
            onChange({ target: { name: "categorieId", value: categorie.id } }, categorie);
        }

    };


    // UNLEASH exemple
    //<MenuItem key={categorie.id} value={categorie.id} disabled={!enabled && categorie.code === 'ERREUR_ADRESSE_LIVRAISON'}>

    return (
        <TextField
            select
            required={isRequired}
            error={error !== undefined}
            name="categorieId"
            label="Catégorie"
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            helperText={error ? error.errorMsg : afficheAide ? aide : ''}
            fullWidth
            autoFocus={autoFocus}
            disabled={disabled}
        >
            <MenuItem key="first" value={0}>
                <em>Sélectionner une catégorie</em>
            </MenuItem>
            {categories.map(categorie => (
                <MenuItem key={categorie.id} value={categorie.id}>
                    {categorie.libelle}
                </MenuItem>
            ))}
        </TextField>
    );
}

CategorieSelect.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool.isRequired,
    afficheAide: PropTypes.bool.isRequired,
    error: PropTypes.object,
    autoFocus: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default CategorieSelect;
